import React, { useEffect, useState } from 'react';
import { Sparkles } from 'lucide-react';

export default function SplashScreen() {
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setHidden(true), 1800);
    return () => clearTimeout(t);
  }, []);

  if (hidden) return null;

  return (
    <div className="splash-screen">
      <div className="splash-orbit splash-orbit-one" />
      <div className="splash-orbit splash-orbit-two" />
      <div className="splash-grid" />
      <div className="splash-content">
        <div className="splash-logo">
          <Sparkles className="w-9 h-9 text-white" />
        </div>
        <h1>CihanStock</h1>
        <p>Premium görsel indirme ve tasarım araçları yükleniyor</p>
        <div className="splash-loader"><span /></div>
      </div>
    </div>
  );
}
